/** Brand palette, route list, and form defaults for Branch Teams. */

import { sharedInputSx } from '../Products/kitchenProductsConstants';

/**
 * Three-tone palette
 *   dark   — deep midnight navy  #181436  (headings / small buttons)
 *   blue   — rich indigo/purple  #5145cd  (primary interactions / accents — key kept "blue" for compat)
 *   orange — vivid signal orange #fc5d1b  (primary CTA / hero icon)
 */
export const BRAND = { dark: '#181436', blue: '#5145cd', orange: '#fc5d1b' };

/**
 * Extended palette used across the module.
 * Import where needed: import { BRAND, PALETTE } from './branchTeamsConfig';
 */
export const PALETTE = {
  pageBg:        '#FFFAF0',
  pageGradient:  'linear-gradient(135deg, #faf3e1 0%, rgb(255, 250, 240) 100%)',
  cardBg:        '#FFFFFF',
  border:        '#EBE4D6',
  borderStrong:  '#D6CCBA',
  tableHeadBg:   '#FAFAF8',
  tableHover:    '#F4F3FF',
  textPrimary:   '#181436',
  textSecondary: '#4A4468',
  textMuted:     '#8C88AA',
  // purple tints  (#5145cd)
  purpleLight:   '#EEEFFE',
  purpleBorder:  '#C5BFEE',
  // orange tints  (#fc5d1b)
  caramelLight:  '#FFF2EC',
  caramelBorder: '#FFC4A8',
  // shadows
  shadowSoft:    '0 2px 16px rgba(24,20,54,0.06)',
  shadowLift:    '0 10px 32px rgba(24,20,54,0.10)',
  shadowOrange:  '0 8px 24px rgba(252,93,27,0.28)',
  shadowPurple:  '0 8px 24px rgba(81,69,205,0.22)',
};

export const ALL_ROUTES = [
  { route: '/storemanagement', label: 'Store Management' },
  { route: '/connectedusers', label: 'Connected Accounts' },
  { route: '/ordermanagement', label: 'Order Management' },
  { route: '/products', label: 'Products' },
  // { route: '/teams', label: 'Teams' },
  // { route: '/squads', label: 'Team Squads' },
  { route: '/storeleads', label: 'Store Leads' },
  { route: '/zipcodemap', label: 'Zipcode Map' },
  { route: '/productagent', label: 'AI Agent — Product' },
  { route: '/logoagent', label: 'AI Agent — Logo' },
  { route: '/menuuploadjobs', label: 'Menu Upload Jobs' },
  { route: '/marketinglead', label: 'Marketing Lead' },
];

export const BLANK_ROUTE_ENTRY = (route) => ({
  route,
  is_active: false,
  access: { read: false, write: false, edit: false, delete: false },
});

export const BLANK_FORM = {
  firstName: '',
  lastName: '',
  email: '',
  phone_no: '',
  password: '',
  team_user_id: '',
  user_type: 'team_member',
  dedicatedRole: 'marketing',
  manual_notes: '',
};

/** Same outlined field styling as Kitchen Products (`sharedInputSx`). */
export const fieldSx = { ...sharedInputSx };

/** Multiline fields: keep kitchen border/colors; allow height to grow past 42px. */
export const fieldSxMultiline = {
  ...sharedInputSx,
  '& .MuiOutlinedInput-root': {
    ...sharedInputSx['& .MuiOutlinedInput-root'],
    height: 'auto',
    minHeight: '42px',
    alignItems: 'flex-start',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
};

export const ACCESS_KEYS = ['read', 'write', 'edit', 'delete'];

export const PERM_KEYS = ['read', 'write', 'edit', 'delete'];
